export default {
  app: {
    languagePopup: {
      title: 'Du er for øyeblikket på den engelske versjonen av {logo}',
      subtitle: 'Vil du bytte til ditt foretrukne språk?',
      cta: 'Bytt til {lang}',
    },
  },
};
